export class PMOTaskCreationModel {
    constructor() {
        this.projectId = "";
        this.taskName = "";
        this.taskDescription = "";
    }
}
export default class PMOTaskCreation extends PMOTaskCreationModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
